import { createApp } from 'vue'
import App from './App.vue'
import router from './router.js'
import { formatDate, api } from './App.vue'
import { StatusCodes } from 'http-status-codes'

const app = createApp(App)

// Register global properties
app.config.globalProperties.$formatDate = formatDate
app.config.globalProperties.$api = api
app.config.globalProperties.$StatusCodes = StatusCodes

app.use(router).mount('#app')
